import React from "react";
import { CalendarDays } from "lucide-react";
import { QueryObserverResult } from "react-query";
import {
  COLOURS,
  MigrationSetImport,
  MigrationSetWithImports,
} from "../../shared";
import { Card } from "../card";

interface CardEventProps {
  currentMigrationSetId: number;
  data: { imports: MigrationSetImport[] } | undefined;
  cardsState: Record<string, any>;
  disableButtonAccess: boolean;
  refetchMigrationSet: () => Promise<
    QueryObserverResult<MigrationSetWithImports, unknown>
  >;
}

export const CardEvent: React.FC<CardEventProps> = ({
  currentMigrationSetId,
  data,
  cardsState,
  disableButtonAccess,
  refetchMigrationSet,
}) => {
  return (
    <Card
      image={
        <CalendarDays
          color={COLOURS.cardIconColor}
          strokeWidth={2}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        />
      }
      importType="event"
      templateKey="eventImport"
      fileName="event.csv"
      migrationSetId={currentMigrationSetId}
      migrationSetImport={data?.imports.find((i) => i.importType === "event")}
      headerText="Calendar Events"
      description="Events can optionally be associated with a Matter. By default, the firm address set in the Smokeball settings determines the time zone for events, but may be overridden by specifying a time zone on each event."
      cardState={cardsState["event"]}
      disableButtonAccess={disableButtonAccess}
      refetchMigrationSet={refetchMigrationSet}
    />
  );
};
